"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NpcSessionTickScheduler = void 0;
exports.createNpcSessionTickSchedulerIfEnabled = createNpcSessionTickSchedulerIfEnabled;
/**
 * Optional interval-based NPC updates for a single {@link GameEngine} (one game session).
 *
 * **MVP pause behavior:** The scheduler only runs while the host keeps it started — typically
 * for the lifetime of an active session. When the session ends, call {@link stop} and release
 * the engine; no ticks run without an active session instance.
 *
 * Create via {@link createNpcSessionTickSchedulerIfEnabled} when the adventure defines
 * `tickIntervalMs`; otherwise time-based NPC ticks are disabled (state-change ticks still run
 * from {@link GameEngine.selectOption}).
 */
class NpcSessionTickScheduler {
    constructor(engine, intervalMs) {
        this.engine = engine;
        this.intervalMs = intervalMs;
        if (!Number.isFinite(intervalMs) || intervalMs <= 0) {
            throw new Error(`NpcSessionTickScheduler: invalid intervalMs ${intervalMs}`);
        }
    }
    /** Start repeating `engine.runNpcTickForActiveNpcs()` every `intervalMs`. */
    start() {
        this.stop();
        this.timer = setInterval(() => {
            this.engine.runNpcTickForActiveNpcs();
        }, this.intervalMs);
    }
    /** Clear the interval; safe to call multiple times. */
    stop() {
        if (this.timer !== undefined) {
            clearInterval(this.timer);
            this.timer = undefined;
        }
    }
    /** True if {@link start} was called and {@link stop} has not cleared the timer. */
    isRunning() {
        return this.timer !== undefined;
    }
}
exports.NpcSessionTickScheduler = NpcSessionTickScheduler;
/**
 * Returns a scheduler when the session’s adventure has a positive `tickIntervalMs`; otherwise `null`.
 */
function createNpcSessionTickSchedulerIfEnabled(engine, adventureManager) {
    const session = engine.getGameSession();
    const adventure = adventureManager.getAdventure(session.adventureId);
    const ms = adventure?.tickIntervalMs;
    if (ms === undefined || ms === null || !Number.isFinite(ms) || ms <= 0) {
        return null;
    }
    return new NpcSessionTickScheduler(engine, Math.floor(ms));
}
//# sourceMappingURL=NpcSessionTickScheduler.js.map